import IaContainer, { IaMode } from "components/IaContainer/IaContainer";
import IconButton from "core/components/IconButton";
import Modal from "core/feedback/Modal";
import { LayoutGroup, motion } from "framer-motion";
import { memo } from "react";
import "./ModalInsightsViagem.css";

interface ModalInsightsViagemProps {
	open: boolean;
	onClose: () => void;
}

function ModalInsightsViagem({ open, onClose }: ModalInsightsViagemProps) {
	return (
		<Modal onClose={onClose} isOpen={open}>
			<LayoutGroup>
				<motion.div
					layout="position"
					layoutId="ia-container-wrapper"
					initial={{ opacity: 0, y: 50 }}
					exit={{ opacity: 0, y: 50 }}
					animate={{
						opacity: 1,
						y: 0,
					}}
					transition={{
						duration: 0.3,
						layout: { duration: 0.24, ease: "easeOut" },
					}}
					onClick={(e) => e.stopPropagation()}
					className="modal-insights-viagem-container"
				>
					<div className="modal-encontrar-veiculo-header-title">
						<div
							style={{
								width: 24,
								flexShrink: 0,
							}}
						/>
						<span>Gerar resumo da viagem</span>
						<IconButton
							icon="X"
							size="lg"
							borderColor="none"
							onClick={onClose}
							backgroundColor="rgba(0, 0, 0, 0)"
							theme="dark"
						/>
					</div>
					<IaContainer
						hideTitle
						hiddenModes={[IaMode.LEGISLACAO, IaMode.LOCALIZACAO]}
					/>
				</motion.div>
			</LayoutGroup>
		</Modal>
	);
}

export default memo(ModalInsightsViagem);
